import { emptyFragment, useOpenable } from '@execonline-inc/execonline-ui';
import { whenZero } from '@execonline-inc/numbers';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../../../CurrentCollectionStep/BuilderV2/Types';
import {
  getCompetencies,
  handleEnterKeyDown,
  handleMouseDown,
} from '../../../../Previewer/Ready/Details/DefaultSection/PopoverContent/Types';
import CompetenciesSection from './CompetenciesSection';
import ExperienceCompetencyChip from './ExperienceCompetencyChip';

export interface Props {
  experienceResource: ExperienceResource;
}

function ExperienceCompetency({ experienceResource }: Props) {
  const { isOpen: expanded, onOpen } = useOpenable();
  const items = getCompetencies(experienceResource.payload.competency_names, expanded);
  const restCount = experienceResource.payload.competency_names.length - items.length;
  return (
    <CompetenciesSection>
      <div className="flex flex-wrap gap-1 sm:gap-2">
        {items.map((competency, index) => (
          <ExperienceCompetencyChip key={index}>{competency}</ExperienceCompetencyChip>
        ))}
        {whenZero(restCount)
          .map(emptyFragment)
          .getOrElse(() => (
            <ExperienceCompetencyChip
              tabIndex={0}
              className="cursor-pointer"
              onClick={handleMouseDown(onOpen)}
              onKeyDown={handleEnterKeyDown(onOpen)}
            >
              +{restCount}
            </ExperienceCompetencyChip>
          ))}
      </div>
    </CompetenciesSection>
  );
}

export default observer(ExperienceCompetency);
